import { useMemo } from "react";

import { GridRowsProp } from "@mui/x-data-grid";
import moment from "moment";

import { EVENTS_DATE_FORMAT } from "../../common/events.constants";
import {
  IFireEventsTableRow,
  IParsedFireEvent,
} from "../../common/events.models";
import { useGetTimestreamData } from "../../common/hooks/useGetTimestreamData";
import { getRowIndex } from "../../common/events.helpers";

export const useGetFireEventsTableRows = () => {
  const {
    parsedResult,
    loading,
    paginationModel,
    handlePaginationModelChange,
    hasNextPage,
    isActivePageChange,
  } = useGetTimestreamData();

  const rows = useMemo((): GridRowsProp<IFireEventsTableRow> => {
    const mappedData: IFireEventsTableRow[] =
      parsedResult?.map((item: IParsedFireEvent, index: number) => ({
        rowIndex: getRowIndex(paginationModel, index),
        rowId: item?.id ?? "",
        location: item?.location_id,
        timestamp: moment.utc(item?.time).local().format(EVENTS_DATE_FORMAT),
        keyFrame: item?.keyFrame,
        mediaOutput: item?.mediaOutput,
        signedUrlKeyFrame: item?.signedUrlKeyFrame,
        signedUrlMediaOutput: item?.signedUrlMediaOutput,
        cameraId: item?.camera_id,
        confidence: item?.confidence,
      })) ?? [];

    return mappedData;
  }, [parsedResult, paginationModel]);

  return {
    rows,
    loading,
    paginationModel,
    handlePaginationModelChange,
    hasNextPage,
    isActivePageChange,
  };
};
